module.exports = __webpack_public_path__ + "static/media/shortinglistup-white.4d98ce31.svg";